import BaseModal from "../../components/BaseModal";
import { Experience } from "../../interfaces/ExperienceProduct";
import { ModalInterface } from "../../interfaces/ModalInterface";

export default function ProductModal(props: ModalInterface<Experience>) {
  const { modal, setModal } = props;

  return modal.selected ? (
    <BaseModal
      modal={modal}
      setModal={setModal}
      children={undefined}
    ></BaseModal>
  ) : (
    <></>
  );
}
